import { User } from 'lucide-react';

import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar';
import { MEDIA_URL } from '@/config';

import { MessageGroup } from '../types';

import { ChatBubble } from './ChatBubble';

export const ItemGroup = ({ group }: { group: MessageGroup }) => {
  return (
    <div
      className={`ms-auto flex max-w-md gap-x-2 ${
        group.isUserMessage && 'flex-row-reverse text-end'
      }`}
    >
      <div className="mt-auto shrink-0">
        <Avatar className="h-8 w-8">
          <AvatarImage
            src={`${
              group.user.profile_photo.includes('https')
                ? group.user.profile_photo
                : `${MEDIA_URL}/${group.user.profile_photo}`
            }`}
          />
          <AvatarFallback className="bg-secondary">
            <User width={12} />
          </AvatarFallback>
        </Avatar>
      </div>
      <ChatBubble group={group} />
    </div>
  );
};
